import { MapPin, Phone, ArrowRight, ShieldCheck } from 'lucide-react';
import branchesData from '../data/branchesData';

function Branches({ goToEnquiry }) {
  return (
    <section id="branches" className="py-24 bg-gradient-to-b from-white to-blue-50/40 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(to right, #3b82f6 1px, transparent 1px), linear-gradient(to bottom, #3b82f6 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 animate-fadeInUp">
          <div className="inline-block mb-4">
            <span className="bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold">
              Our Locations
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Our Branches</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visit us at any of our office locations — we'd love to meet you in person
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {branchesData.map((branch, index) => (
            <div
              key={branch.id}
              className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 border border-gray-100 animate-fadeInUp"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="bg-gradient-to-br from-blue-300 to-black w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all">
                  <MapPin className="h-8 w-8 text-white" />
                </div>
                <span className="bg-blue-50 text-blue-900 text-xs font-bold px-3 py-1.5 rounded-full">
                  Branch {index + 1}
                </span>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-900 transition-colors">
                {branch.name}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg mb-4">{branch.address}</p>

              <div className="flex items-center space-x-2 text-gray-700 mb-6">
                <Phone className="h-5 w-5 text-blue-900 flex-shrink-0" />
                <span className="font-medium">{branch.phone}</span>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center space-x-2 text-gray-400">
                  <ShieldCheck className="h-5 w-5" />
                  <span className="text-sm font-medium">GST details available on enquiry</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center animate-fadeInUp" style={{ animationDelay: '300ms' }}>
          <button
            onClick={goToEnquiry}
            className="group inline-flex items-center space-x-2 bg-gradient-to-r from-blue-300 to-black text-white px-8 py-4 rounded-full hover:shadow-2xl transition-all transform hover:scale-105 font-semibold text-lg relative overflow-hidden"
          >
            <span className="relative z-10">Enquire to View GST Details</span>
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform relative z-10" />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-300 to-blue-950 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Branches;
